import { TimeInput, TimeInputProps } from "@heroui/react";
import { MantineFormValues } from "./shared.types";
import React from "react";
import { isMobileSafari } from "react-device-detect";
import { cn } from "@/utils";
import { isNativePlatform } from "@/utils/native";

type TimeInput = MantineFormValues & TimeInputProps;

export const LimeTimeInput = React.forwardRef(
  ({ error, ...props }: TimeInput, ref: React.Ref<HTMLInputElement>) => (
    <TimeInput
      ref={ref}
      errorMessage={error}
      isInvalid={!!error}
      {...props}
      classNames={{
        ...props.classNames,
        input: cn(props.classNames?.input, {
          "text-[16px]": isMobileSafari || isNativePlatform(),
        }),
      }}
    />
  ),
);
LimeTimeInput.displayName = "LimeTimeInput";
